var React = require('react');

function BackendDropdownMenuServers (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#000000","d":"M13 0h-10l-3 4h16l-3-4z","key":0}),React.createElement("path",{"fill":"#000000","d":"M0 5v3h16v-3h-16zM15 7h-1v-1h1v1z","key":1}),React.createElement("path",{"fill":"#000000","d":"M0 9v3h16v-3h-16zM15 11h-1v-1h1v1z","key":2}),React.createElement("path",{"fill":"#000000","d":"M0 13v3h16v-3h-16zM15 15h-1v-1h1v1z","key":3})]);
}

BackendDropdownMenuServers.displayName = "BackendDropdownMenuServers";

BackendDropdownMenuServers.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = BackendDropdownMenuServers;

BackendDropdownMenuServers.default = BackendDropdownMenuServers;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-dropdown-menu-servers.svg
// module id = 495
// module chunks = 0